<template>
  <div class="row">
    <div class="col-md-12">
      <div class="addon-wrapper">
        <div class="addon-info-wrapper">
          <!-- title -->
          <h5 class="addon-title">
            {{ addon.title }}

            <span v-if="addon.limit > 0"> - {{ addon.actual_limit }} Spaces Left</span>
          </h5>

          <!-- price -->
          <div class="addon-price default-color">
            {{ currencySymbol }}{{ addon.price }}
          </div>

          <!-- description -->
          <div class="addon-description">
            {{ addon.description }}
          </div>
        </div>

        <div class="addon-quantity-wrapper">
          <!-- quantity -->
          <select
            class="form-control addons"
            v-model="addon.selected"
            @change="onUpdateSelectedAddons"
          >
            <option value="0">0</option>
            <option v-for="quantity in addon.available_limit" :key="`addon-${addon.id}-quantity`" :value="quantity">
              {{ quantity }}
            </option>
          </select>
        </div>
      </div>

      <hr v-if="showLine" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    addonsLength: {
      type: Number,
      default: 0
    },
    addon: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters("basketStore", [
      "slug",
      "conference",
      "tickets",
      "currencySymbol",
      "settings",
      "donation"
    ]),


    showLine() {
      return (this.index + 1) !== this.addonsLength;
    }
  },
  methods: {
    ...mapActions('basketStore', ['updateBasket']),

    onUpdateSelectedAddons() {
      const data = {
        tickets: this.tickets
      };

      this.updateBasket(data)
        .then(() => {})
        .finally(() => {});
    }
  }
}
</script>
